import { decomposeColor, Skeleton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { MetricSectionTitleColorCode, MetricSectionTitleContainer, MetricSectionTitlePrognosisTooltip } from './metricSectionTitle.styles';
import { Prognosis } from '../../../components/helpers/metricsHelpers';
import { COLORS } from './colors';

type MetricSectionTitleProps = {
  title: string;
  hasScoring?: boolean;
  prognosis?: Prognosis;
  score: number | undefined;
};

const MetricSectionTitle: React.FC<MetricSectionTitleProps> = ({ title, prognosis, score }) => {
  function getPrognosisColorForScore(prognosis: Prognosis, score: number) {
    const level = prognosis.levels.filter((l) => l.min <= score).sort((a, b) => b.min - a.min)[0];

    return level.color;
  }

  return (
    <MetricSectionTitleContainer>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {title}
        {prognosis && (
          <>
            :{' '}
            {score ? (
              String(score).padStart(2, '0')
            ) : (
              <Skeleton
                variant="text"
                sx={{
                  display: 'inline-block',
                  width: '32px',
                  fontSize: '32px',
                  lineHeight: 1,
                  bgcolor: `rgba(${decomposeColor(COLORS.brand[40]).values},.5)`,
                  verticalAlign: 'bottom',
                }}
                animation="wave"
              />
            )}
            /{prognosis.max}
          </>
        )}
      </Typography>
      {prognosis && score && (
        <Tooltip
          title={
            <MetricSectionTitlePrognosisTooltip>
              <strong>{prognosis.title ? prognosis.title : 'Evaluation Prognosis'}</strong>
              {prognosis.notes && <small>* {prognosis.notes}</small>}
              <ul>
                {prognosis.levels.map((level, i) => {
                  return (
                    <li key={i}>
                      <span style={{ backgroundColor: COLORS.color_blind_friendly[level.color] }} /> {level.label}
                    </li>
                  );
                })}
              </ul>
            </MetricSectionTitlePrognosisTooltip>
          }
        >
          <MetricSectionTitleColorCode color={getPrognosisColorForScore(prognosis, score)} />
        </Tooltip>
      )}
    </MetricSectionTitleContainer>
  );
};

export default MetricSectionTitle;
